import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function N2PackToggle() {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/n2-pack").then((r) => setSt(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const set = async (pack) => {
    if (!st || pack === st.pack) return;
    setBusy(true);
    try { const r = await api.put("/admin/n2-pack", { pack }); setSt(r.data); toast.success(`Paket N2 → ${pack === "mini" ? "Mini (30%)" : "Full (100%)"} · ${r.data.stages} stage`); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="soft-card mb-4 flex flex-wrap items-center justify-between gap-3 p-4" data-testid="n2-pack-card">
      <div>
        <p className="text-sm font-semibold">Paket Kosakata & Kanji N2 (Kanji Word List / Vocabulary Index)</p>
        <p className="text-xs text-muted-foreground">Sumber: JLPT N2 list — J. Waller (tanos.co.uk, CC-BY). Mini = 30% kata inti (kanji paling sering dipakai), Full = seluruh ±1.700 kata & 367 kanji. {st && <span data-testid="n2-pack-stages">Stage aktif: {st.stages}</span>}</p>
      </div>
      <div className="inline-flex rounded-full border border-border bg-card p-1 text-xs" data-testid="n2-pack-toggle">
        {[["mini", "Mini 30%"], ["full", "Full 100%"]].map(([k, l]) => <button key={k} disabled={busy || !st} data-testid={`n2-pack-${k}`} onClick={() => set(k)} className={`rounded-full px-3 py-1 ${st?.pack === k ? "bg-foreground text-background" : "text-muted-foreground"}`}>{l}</button>)}
      </div>
    </div>
  );
}
